import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { NameColumn } from './columns/name';
import { EmployeesCount } from './columns/employees-count';
import { Paginator } from '@app/classes';
import { WorkSchedule } from '@models/time-off-v3/works-schedule.model';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';

export class WorkScheduleTable extends Table {
    static editOption: MenuColumnItem = {
        label: 'time-off-v3.editSchedule',
        event: 'edit-schedule',
    };
    static assignOption: MenuColumnItem = {
        label: 'time-off-v3.assignSchedule',
        event: 'assign-schedule',
    };
    static deleteOption: MenuColumnItem = {
        label: 'time-off-v3.deleteSchedule',
        event: 'delete-schedule',
    };

    showMenuColumnOptions = true;

    constructor(auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.columns = [new NameColumn(), new EmployeesCount()];
    }

    setDataSource(): void {
        this.paginator = new Paginator(WorkSchedule.with('employees').limit(50), {
            pageSize: 50,
        });
    }

    getMenuColumnOptionsForRow(workSchedule: WorkSchedule): MenuColumnItem[] {
        if (workSchedule.isDefault) {
            return [WorkScheduleTable.editOption];
        }

        return [WorkScheduleTable.editOption, WorkScheduleTable.assignOption, WorkScheduleTable.deleteOption];
    }
}
